var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button bg-sec text-white px-8 py-3 focus:outline-none"},[_vm._v(" CLOSE "),_c('feather',{attrs:{"type":"x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }